export default __webpack_public_path__ + "static/media/china.053193ff.png";